var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLandingLine1920 = function SvgLandingLine1920(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 215,
    height: 1699,
    fill: "none",
    className: "landing-line-1920_svg__landing-line-1920"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 3,
    d: "M124 .5v61.495A114.91 114.91 0 0 0 168.75 153a114.91 114.91 0 0 1 44.75 91.005v221.61a114.5 114.5 0 0 1-16 58.385 114.5 114.5 0 0 0-16 58.385v175.251c0 52.087-38.408 96.198-90 103.364s-90 51.277-90 103.364V1091c0 50.26 40.742 91 91 91s91 40.74 91 91v169.94c0 25.63 2.753 51.19 8.211 76.24l.578 2.64a358 358 0 0 1 8.211 76.24v100.44"
  })));
};
export default SvgLandingLine1920;